import moment from "moment";
import Button, { BUTTON_TYPE_CLASSES } from "../../button/button.component";
import Countdown from "../../countdown/countdown.component";
import { AUCTION_TYPE } from "../auction-status/auction-status.component";
import { ReactComponent as ProgressIcon } from "../../../icons/auction.svg";
import { ReactComponent as CalendarIcon } from "../../../icons/calendar (1).svg";
import {
  formatMoneyNumber,
} from "../../../Utils/common.utils";
import {
  CMCurrentPrice,
  CMDetailsCard,
  CMDetailsContainer,
  CMImage,
  CMIncrease,
  CMLiveTag,
  CMMobileCard,
  CMProgressCard,
  CMTradeCard,
  CMTradeDetails,
  CMUpcomingCard,
  CMUpcomingDetailsCard,
  LoadContent,
  TransactionContend,
} from "./public-auction-card.styles";
import AuctionMetrics from "../auction-metrics/auction-metrics.component";
import AuctionCarousel, {
  AUCTION_CAROUSEL_TYPE,
  imgBreakpoints,
} from "../auction-carousel/auction-carousel.component";
import { ReactComponent as ArrowIcon } from "../../../icons/large-arrow.svg";
import { ReactComponent as DownArrowIcon } from "../../../icons/down-arrow-7361.svg";
import { ReactComponent as AuctionIcon } from "../../../icons/auction.svg";
import Progress, { PROGRESS_TYPE } from "../../progress/progress.component";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlaceBid from "../../place-bid/place-bid/place-bid.component";
import PlaceOrder from "../../place-order/place-order/place-order.component";
import TVChartContainer from "../../TVChartContainer";
import { toast } from "react-toastify";
import { getPairListWithSymbol } from "../../../Services/trading-board.service";
import { Checkbox, FormControlLabel } from "@mui/material";
import Modal from "react-modal";
import { useAuth } from "../../../Contexts/auth.context";
import { getNotifyoptions, updateNotifyoptions } from "../../../Services/auction.service";
import iconUrl from '../../../Assets/increase.png'; 
import arrowUpdate from '../../../icons/arrow-update.png';
import LoadingChild from "../../loading-child/loading-child.component";
import LoginRequired from "../../login-required/login-required.component";

moment.tz.setDefault("EST");
const getAuctionCard = (cardType = AUCTION_TYPE.progress.id) =>
({
  [AUCTION_TYPE.progress.id]: ProgressCard,
  [AUCTION_TYPE.scheduled.id]: ScheduledCard,
  [AUCTION_TYPE.upcoming.id]: UpcomingCard,
  [AUCTION_TYPE.mobile.id]: MobileCard,
  [AUCTION_TYPE.details.id]: DetailsCard,
  [AUCTION_TYPE.trade.id]: TradeCard,
}[cardType]);

const PublicAuctionCard = ({ auction, setRefreshDetailsPage, refreshDetailsPage, setAuction, cardType, ...props }) => {
  const CMAuctionCard = getAuctionCard(cardType);
  return (
    <div>
      <CMAuctionCard auction={auction} {...props} setRefreshDetailsPage={setRefreshDetailsPage} setAuction={setAuction} refreshDetailsPage={refreshDetailsPage}/>
    </div>
  );
};

const ProgressCard = ({ auction }) => {
  const [currentBids, totalBids] = auction?.BidedUnits.split('/');
  const cleanedCurrentBids = parseFloat(currentBids.replace(/,/g, '')); 
  const cleanedTotalBids = parseFloat(totalBids.replace(/,/g, '')); 


  return (
    <CMProgressCard>
      <CMLiveTag>LIVE</CMLiveTag>
      {cleanedCurrentBids > cleanedTotalBids &&
      <CMIncrease src={iconUrl} alt="Icon" style={{ width: '15px', height: '15px', marginRight: '5px' }} />
      }
      <h4>Auction ends in</h4>
      <h4>
        {auction.endDate &&
          <Countdown date={auction.endDate} onCountdownEnd={(ended) => { if (ended && auction) { window.location.reload(); } }} />
        }
      </h4>
      <ProgressIcon />
      <Button as={Link} to={`auction?id=${auction.auctionID}`} size="medium">
        Go to auction
      </Button>
      {cleanedCurrentBids > cleanedTotalBids &&
        <span style={{color:"rgb(116, 201, 50)", marginTop:"10px"}}>(High Demand)</span>
      }
      
    </CMProgressCard>
  );
};

const ScheduledCard = ({ auction }) => {
  return (
    <CMUpcomingCard>
      <h4 style={{ marginBottom: "10px" }}>Scheduled auction</h4>
      <div>
        <div>
          <h4>{moment(auction.startDate).format("MMMM Do YYYY")}</h4>
          <CalendarIcon />
        </div>
        <Button to={""} size="medium">
          Notify
        </Button>
      </div>
    </CMUpcomingCard>
  );
};

const UpcomingCard = ({ auction }) => {
  const [daysLeft, setDaysLeft] = useState(0);
  useEffect(() => {
    setDaysLeft(moment(auction.startDate).diff(moment(), 'days'));
  }, [auction.startDate])
  return (
    <CMUpcomingCard style={{ backgroundColor: "#f8f8f8" }}>
      <h4>Start Soon!</h4>
      <div>
        <div>
          <h4>{moment(auction.startDate).format("MMMM Do YYYY")}</h4>
          <CalendarIcon />
        </div>
        <h4 hidden={daysLeft >= 7}>
            {auction.startDate && 
            <Countdown  date={auction.startDate} onCountdownEnd={(ended) => { if (ended) { window.location.reload(); } console.log(ended)} } />
            }
        </h4>
        <Button as={Link} to={`auction?id=${auction.auctionID}`} size="medium">
          Go to auction
        </Button>
      </div>
    </CMUpcomingCard>
  );
};

const MobileCard = ({ auction }) => {
  return (
    <CMMobileCard>
      <CMLiveTag>LIVE</CMLiveTag>
      <ProgressIcon />
      <h4>Auction ends in</h4>
      <h4>
        {auction.endDate && 
        <Countdown date={auction.endDate} onCountdownEnd={(ended) => { if (ended) { window.location.reload(); } }} />
        }
      </h4>
      <AuctionCarousel
        slides={auction.imgSrc}
        carouselType={AUCTION_CAROUSEL_TYPE.imageSemiRounded}
        breakpoints={imgBreakpoints}
        auctionID={auction.auctionID}
      />
      <Button as={Link} to={`auction?id=${auction.auctionID}`} size="medium">
        Go to auction
      </Button>
    </CMMobileCard>
  );
};

const DetailsCard = ({ auction, setRefreshDetailsPage, setAuction, refreshDetailsPage }) => {
  // This card showing social media listeners

  const [open, setOpen] = useState(false);
  const [activeStep, setActiveStep] = useState();
  const [refreshChild, setRefreshChild] = useState(false);
  const [currentBids, totalBids] = auction?.BidedUnits.split('/');
  const cleanedCurrentBids = parseFloat(currentBids.replace(/,/g, '')); 
  const cleanedTotalBids = parseFloat(totalBids.replace(/,/g, '')); 

  // orderConfirm 'true' Goto Confirm Bid  Screen
  // orderConfirm 'false' Goto Funds Insufficient funds Screen
  const [orderConfirm, setOrderConfirm] = useState(true);

  const handleOpenBidding = () => {
    setOpen(true);
    setActiveStep(0);
    setRefreshChild((prevState) => !prevState);
  };
  const handleOpenOffer = () => {
    setOpen(true);
    setActiveStep(0);
    setRefreshChild((prevState) => !prevState);
  };
  const handleClose = () => setOpen(false);

  
  return (
    <>
      {auction.status === AUCTION_TYPE.progress.id && auction.main_status !== "Closed" ? (
        <CMDetailsCard>
          <CMImage>
            <AuctionIcon />
          </CMImage>
          <div className="details">
            <div>
              <CMLiveTag>LIVE</CMLiveTag>
              <Button
                onClick={handleOpenBidding}
                buttonType={BUTTON_TYPE_CLASSES.TextButton}
                size="small"
                color="blue"
                className="bidding-details"
              >
                Bidding Details
              </Button>
              <h3 className="live-title">Live auction ends in</h3>
              <h3 className="live-title">
                {auction.endDate &&
                  <Countdown date={auction.endDate} onCountdownEnd={(ended) => { if (ended) { window.location.reload(); } }} />
                }
              </h3>
            </div>
            <CMDetailsContainer>
              <div>
                <Button onClick={handleOpenOffer}>Make an offer</Button>

                <div>
                  <div>
                    <div>
                      <Progress
                        value={auction.progress}
                        progressType={PROGRESS_TYPE.linear}
                        conditionIcon={cleanedCurrentBids > cleanedTotalBids}
                      />
                       {cleanedCurrentBids > cleanedTotalBids &&
                      <p>Commited <span>(High Demand)</span></p>
                       }
                    </div>
                  </div>

                  {auction ? (
                    <AuctionMetrics
                      className="details-auction-metrics"
                      spotify={auction.spotifyMonthlyListeners}
                      spotifyChannel={auction.spotifyChannel}
                      instagram={auction.instagramMonthlyListeners}
                      instagramChannel={auction.instagramChannel}
                      youtube={auction.youtubeMonthlyListeners}
                      youtubeChannel={auction.youtubeChannel}
                      facebook={auction.facebookMonthlyListeners}
                      facebookChannel={auction.facebookChannel}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </CMDetailsContainer>
          </div>
          {open &&
            <LoginRequired
              open={open}
              handleClose={handleClose}
              redirectUrl={`/auctions-board/auction?id=${auction.auctionID}`}
            />
          }
        </CMDetailsCard>
      ) : (
        auction.status === AUCTION_TYPE.finished.id || auction.main_status === "Closed" ? (
          <CMDetailsCard>
            <CMImage>
              <AuctionIcon />
            </CMImage>
            <div className="details">
              <div>
                <CMLiveTag>FINISHED</CMLiveTag>
                <h3>The auction has ended.</h3>
              </div>
              <CMDetailsContainer>
                <div>
                  <div>
                    <div>
                      <div>
                        <Progress
                          value={auction.progress}
                          progressType={PROGRESS_TYPE.linear}
                        />
                        <p>Commited</p>
                      </div>
                    </div>
                    {auction ? (
                      <AuctionMetrics
                        className="details-auction-metrics"
                        spotify={auction.spotifyMonthlyListeners}
                        spotifyChannel={auction.spotifyChannel}
                        instagram={auction.instagramMonthlyListeners}
                        instagramChannel={auction.instagramChannel}
                        youtube={auction.youtubeMonthlyListeners}
                        youtubeChannel={auction.youtubeChannel}
                        facebook={auction.facebookMonthlyListeners}
                        facebookChannel={auction.facebookChannel}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </CMDetailsContainer>
            </div>
            {open &&
              <LoginRequired
                open={open}
                handleClose={handleClose}
                redirectUrl={`/auctions-board/auction?id=${auction.auctionID}`}
              />
            }
          </CMDetailsCard>
        )
          : (<UpcomingDetailsCard auction={auction} />)
      )}
    </>
  );
};

const UpcomingDetailsCard = ({ auction }) => {
  const {  auth } = useAuth();
  const [open, setOpen] = useState(false);
  const [auctionStart, setAuctionStart] = useState(false); 
  const [auctionEnd, setAuctionEnd] = useState(false);
  const [notifyData, setNotifyData] = useState();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSave = () => {
    const auctionDetails = {
      UserId: auth.userId,
      UserEmail: auth.emailAddress,
      AuctionID:auction.auctionID,
      AuctionStart: auctionStart,
      AuctionEnded: auctionEnd,
    };

    updateNotifyoptions(auctionDetails)
    .then((response) => {
      if (response) {
        console.log("response",response)
      }
    })
    .catch((err) => console.error(err))

    handleClose();
  };

  useEffect(() => {
    getNotifyoptions(auth?.userId)
    .then((response) => {
      if (response) {
        setNotifyData(response);
      }
    })
    .catch((err) => console.error(err))
  }, [auth])

  useEffect(() => {
    if (notifyData && notifyData.length > 0) {
        notifyData.forEach(notification => {
            if (notification.NotificationType === "auction_start" && notification.auctionId === auction.auctionID) {
                setAuctionStart(true);
            } else if (notification.NotificationType === "auction_ended" && notification.auctionId === auction.auctionID) {
                setAuctionEnd(true);
            }
        });
    }
}, [notifyData, auction, setAuctionStart, setAuctionEnd]);


  
  return (
    <CMUpcomingDetailsCard>
      <CMImage className="upcoming-auction">
        <CalendarIcon width={24} height={24} />
      </CMImage>

      <div className="details">
        <div>
          <h3>Scheduled auction</h3>
          <h5>{moment(auction.startDate).format("MMMM Do YYYY")}</h5>
          <p>Don't miss the date subscribe to this auction</p>
        </div>
        <div className="metrics-container">
          <div hidden>
            {auction.startDate && 
            <Countdown  date={auction.startDate} onCountdownEnd={(ended) => { if (ended) { window.location.reload(); } console.log(ended)} } />
            }
          </div>
          <div>
          <Button onClick={()=>{handleOpen()}} size="big" >
          Notify
        </Button>
          </div>
          {auction ? (
            <AuctionMetrics
              className="details-auction-metrics"
              spotify={auction.spotifyMonthlyListeners}
              spotifyChannel={auction.spotifyChannel}
              instagram={auction.instagramMonthlyListeners}
              instagramChannel={auction.instagramChannel}
              youtube={auction.youtubeMonthlyListeners}
              youtubeChannel={auction.youtubeChannel}
              facebook={auction.facebookMonthlyListeners}
              facebookChannel={auction.facebookChannel}
            
            />
          ) : (
            ""
          )}
        </div>
        
      </div>
      <Modal
        isOpen={open}
        onRequestClose={handleClose}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: "99999"
          },
          content: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'static',
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: "none",
            padding: '0',
            height: '100%',
            zIndex: "99999"
          }
        }}
      >
        <div style={{
          padding: "20px",
          backgroundColor: "white",
          borderRadius: "20px",
          maxWidth: "400px",
          width: "100%",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          zIndex: "99999"
        }}>
          <div style={{textAlign:"right",marginBottom:"-25px"}}>
            <button 
              onClick={handleClose} 
              style={{
                background: 'none',
                border: 'none',
                color: 'gray',
                fontSize: '2rem',
                cursor: 'pointer'
              }}
            >
              &times; 
            </button>
          </div>
           
          <h3>Notify Options</h3>
          <FormControlLabel
            control={<Checkbox checked={auctionStart} onChange={(e) => setAuctionStart(e.target.checked)} />}
            label="Start Auction"
          />
          <FormControlLabel
            control={<Checkbox checked={auctionEnd} onChange={(e) => setAuctionEnd(e.target.checked)} />}
            label="End Auction"
          />
          <Button onClick={handleSave} variant="contained" color="primary" style={{ marginTop: "20px" }}>
            Save
          </Button>
        </div>
      </Modal>
    </CMUpcomingDetailsCard>
    
  );
};

const TradeCard = ({ auction}) => {
  const [open, setOpen] = useState(false);
  const [tradeError, setTradeError] = useState({});
  const [changeTrading, setChangeTrading] = useState([]);
  const [symbolData, setSymbolData] = useState([]);
  const [reload, setReload] = useState(false);

  const markets = [
    {
      "pair_key": `${auction?.symbol?.toLowerCase()}_usd`,
      "pairs": `${auction?.symbol?.toLowerCase()}_usd`,
      "pairsCombined": `usd${auction?.symbol?.toLowerCase()}`,
      "pairsRevOrder": `usd_${auction?.symbol?.toLowerCase()}`
    }
  ];

  const getPriceIncrease = async () => {
    try {
      setReload(true);
      const resPairFees = await getPairListWithSymbol(auction?.symbol);
      setChangeTrading(resPairFees?.data?.change_percentage);
      setSymbolData(resPairFees?.data)
      setReload(false);
    } catch (error) {
      console.log(error);
    } 
  }

  useEffect(() => {
    getPriceIncrease();
  }, [])

  const handleOpenBidding = () => {
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const handleButtonClick = () => {
    getPriceIncrease();
  };

  
  return (
    <CMTradeCard>
      <Button
        as={Link}
        to={""}
        onClick={
          tradeError?.message === "Invalid coin id."
            ? () => toast.error(tradeError?.message)
            : handleOpenBidding
        }
        color="blue"
        className="tradeButton"
      >
        TRADE
      </Button>
      <div className="details">
        <CMCurrentPrice>
          {reload ?
          <LoadContent>
            <LoadingChild />
          </LoadContent>
        :
          <>
            <div className="current-price-trade">
            <h5 style={{display:"flex"}}>
              Current price:
              <TransactionContend className="transaction-button" onClick={handleButtonClick}  disabled={reload}>
                <img src={arrowUpdate} />
              </TransactionContend>
              </h5>
             <p>${formatMoneyNumber(symbolData?.lastPrice) || "0.00"}</p>
            <h6>Price per unit</h6>
          </div>
          <div className="profits">
            <div>
              {Math.sign(changeTrading) === -1 ? <DownArrowIcon style={{ position: "relative", top: "7%" }}/> :<ArrowIcon style={{ position: "relative", top: "7%" }} />}
              <p style={{color: Math.sign(changeTrading) === -1 ? 'red':'green'}}>{changeTrading || 0}%</p>   
            </div>                     
            <h6>Price per unit</h6>
          </div>
          <div className="advance-trade-link">
          <button onClick={() => {
              localStorage.setItem("defaultPair", `${auction?.symbol}_USD`)
              setTimeout(() => {
                window.location.href = `${window.location.origin}/exchange/symbol/${auction?.symbol}_USD`;
            }, 100);
            }}>Advance Trade</button>
          </div>
          </>
          }
          
        </CMCurrentPrice>
        <CMTradeDetails>
        {(changeTrading != 0) && (changeTrading!=null) && (changeTrading !=undefined) ? (
               <TVChartContainer
               theme={'light'}
               pair1={`${auction?.symbol}`}
               pair2={'USD'}
               kline={{}}
               currentMarket={`${auction?.symbol}_USD`}
               markets={markets}
               decimalValue={100}
               refreshExchange={false}
             // className="tradingChart"
             />
          ) : (
            <div style={{width:'100%', height:'30vh'}}>
              <p style={{textAlign:'left', fontWeight:'600', fontSize:'1.2rem'}}>Price performance</p>
              <div style={{color:'#a80000',width:'100%', height:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                <p>No recent trading data</p>
              </div>
            </div>
          )}
       
          {auction ? (
            <AuctionMetrics
              className="details-auction-metrics"
              spotify={auction?.spotifyMonthlyListeners}
              spotifyChannel={auction?.spotifyChannel}
              instagram={auction?.instagramMonthlyListeners}
              instagramChannel={auction?.instagramChannel}
              youtube={auction?.youtubeMonthlyListeners}
              youtubeChannel={auction?.youtubeChannel}
              facebook={auction.facebookMonthlyListeners}
              facebookChannel={auction.facebookChannel}
              SymbolView={true} 
            />
          ) : (
            <br />
          )}
        </CMTradeDetails>
      </div>
      <PlaceOrder
        open={open}
        handleClose={handleClose}
        auction={auction}
        setTradeError={setTradeError}
      />
    </CMTradeCard>
  );
};

export default PublicAuctionCard;
